const W404 = () => {
    return (
      <div className="w404">
        <h3>404 Error</h3>
        <p>Sorry, the page you requested does not exist!</p>
      </div>
    )
}

export default W404;